import {Component, Input, QueryList, ViewChildren} from '@angular/core';
import {SupportContact} from '@models/adminstration/organization/support-contact/support-contact';
import {TranslateService} from '@ngx-translate/core';

import {ContactsService} from '@services/administration/organization/configuration/contacts/contacts.service';
import {LoadingIndicatorService} from '@services/loading-indicator/loading-indicator.service';
import {NotificationService} from '@services/notification/notification.service';
import {
  SortEvent,
  TableHeaderSortableDirective
} from '@shared/table-header-sortable/table-header-sortable.directive';
import {TableHeaderSortableService} from '@services/table-header-sortable/table-header-sortable.service';
import {ContactModalComponent} from '@components/administration/organization/configuration/contacts/contact-modal/contact-modal.component';
import {ModalService} from '@services/modal/modal.service';

@Component({
    selector: 'scitis-admin-organization-support-contacts',
    templateUrl: './contacts.component.html',
    styleUrls: ['./contacts.component.scss'],
    standalone: false
})
export class ContactsComponent {

  @Input()
  contacts: SupportContact[] = new Array<SupportContact>();

  @Input()
  organizationId: number = -1;

  @Input()
  organizationName: string = '';

  @Input()
  isAdminRole: boolean = false;
  @Input()
  isSuperAdminRole: boolean = false;
  private COMPONENT_NAME: string = 'ContactsComponent';

  constructor(private modalService: ModalService,
              public translate: TranslateService,
              private loadingIndicator: LoadingIndicatorService,
              private notification: NotificationService,
              private contactsService: ContactsService,
              private tableHeaderSortableService: TableHeaderSortableService) {
  }

  onAddSupportContact() {

    const modalRef = this.modalService.open(ContactModalComponent, {size: 'lg'});
    modalRef.componentInstance.contact = new SupportContact();
    modalRef.result.then((result) => {
      this.contactsService.saveContact(this.organizationId, result).subscribe((success) => {
        const message = this.translate.instant('Support contact') + ' ' + success.name + ' ' +
            this.translate.instant('saved') + '.';
        this.contacts.push(this.contactsService.copyContactProperties(success, null));
        this.notification.success(message, this.COMPONENT_NAME, false);
      }, (error) => {
        this.notification.error(this.translate.instant('Error saving support contact') + ': ' + result.name,
            error, this.COMPONENT_NAME, true);
      });
    });
  }

  //SORTING
  @ViewChildren(TableHeaderSortableDirective) sortableHeaders: QueryList<TableHeaderSortableDirective> = new QueryList<TableHeaderSortableDirective>();

  onColumnSort({column, direction}: SortEvent) {
    this.sortableHeaders = this.tableHeaderSortableService.resetHeaders(this.sortableHeaders, column);
    this.contacts = this.tableHeaderSortableService.sortItems<SupportContact>(this.contacts, column, direction);
  }
}
